import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { Web3Provider, useWeb3 } from './context/Web3Context';
import { LanguageProvider, useLanguage } from './i18n/LanguageContext';
import Header from './components/Header';
import TokenInfo from './components/TokenInfo';
import TransferTokens from './components/TransferTokens';
import Faucet from './components/Faucet';
import MintBurn from './components/MintBurn';
import AdminPanel from './components/AdminPanel';
import EventsPanel from './components/EventsPanel';
import TutorialMode from './components/TutorialMode';
import NFTPage from './pages/NFTPage';
import DocsPage from './pages/DocsPage';
import { Wallet } from 'lucide-react';

function AppContent() {
  const [currentPage, setCurrentPage] = useState('tokens');
  const { isOwner } = useWeb3();
  const { t } = useLanguage();

  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <div className="min-h-screen bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
        <Header currentPage={currentPage} onNavigate={setCurrentPage} />
        
        <main className="container mx-auto px-4 py-8">
          <div className="max-w-6xl mx-auto">
            {currentPage === 'tokens' ? (
              <>
                {/* Hero Section */}
                <div className="text-center mb-12">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg mb-4">
                    <Wallet className="w-10 h-10 text-purple-600" />
                  </div>
                  <h1 className="text-5xl font-bold text-white mb-4">
                    {t('app.title')}
                  </h1>
                  <p className="text-xl text-white/90 max-w-2xl mx-auto">
                    {t('app.subtitle')}
                  </p>
                </div>

                {/* Main Content Grid */}
                {isOwner ? (
                  <>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                      <TokenInfo />
                      <Faucet />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                      <TransferTokens />
                      <MintBurn />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                      <AdminPanel />
                      <EventsPanel />
                    </div>
                  </>
                ) : (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                    <TransferTokens />
                    <Faucet />
                  </div>
                )}
              </>
            ) : currentPage === 'nfts' ? (
              <NFTPage />
            ) : currentPage === 'tutorial' ? (
              <TutorialMode onNavigate={setCurrentPage} />
            ) : (
              <DocsPage />
            )}
          </div>
        </main>

        {/* Footer */}
        <footer className="mt-16 pb-8 text-center text-white/80">
        </footer>
      </div>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Web3Provider>
        <AppContent />
      </Web3Provider>
    </LanguageProvider>
  );
}

export default App;
